import { IoChevronUpCircle } from 'react-icons/all';
import * as React from 'react';
export default {
  IoChevronUpCircle,
  React
};